module.exports = __webpack_public_path__ + "img/fullscreen.6c5ad4a1.png";